import { render, staticRenderFns } from "./FireCauseNeighboorOrigin.vue?vue&type=template&id=1bd98a80&scoped=true"
import script from "./FireCauseNeighboorOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseNeighboorOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseNeighboorOrigin.vue?vue&type=style&index=0&id=1bd98a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd98a80",
  null
  
)

export default component.exports